import { FC, useCallback } from "react";
import { CommitmentsFilterSelect } from "./CommitmentsFilterSelect";
import { lockBackPeriodFilterOptions } from "./utils/contants/filter-options/recommendationsFiltersOptions";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../../store/hooks";
import { setCommitmentsRecommendationsLockBackPeriod } from "../../../../../../../../store/commitments/commitmentsSlice";
import {
  CommitmentType,
  LookbackPeriod,
} from "../../../../../../../../services/cloudchipr.api";
import { commitmentsRecommendationsLockBackPeriodSelector } from "../../../../../../../../store/commitments/selectors/recommendations/filters/commitmentsRecommendationsLockBackPeriodSelector";
import { updateRecommendationFiltersUserPreferenceByKeyThunk } from "@/store/commitments/thunks/recommendations/user-preference/updateRecommendationFiltersUserPreferenceByKeyThunk";

interface CommitmentsLockBackPeriodFilterProps {
  type: CommitmentType;
}
export const CommitmentsLockBackPeriodFilter: FC<
  CommitmentsLockBackPeriodFilterProps
> = ({ type }) => {
  const dispatch = useAppDispatch();
  const value = useAppSelector(
    commitmentsRecommendationsLockBackPeriodSelector,
  );

  const changeHandler = useCallback(
    (period: string[]) => {
      const data = period as LookbackPeriod[];
      dispatch(setCommitmentsRecommendationsLockBackPeriod(data));
      dispatch(
        updateRecommendationFiltersUserPreferenceByKeyThunk({
          key: type,
          value: {
            look_back_period: data,
          },
        }),
      );
    },
    [dispatch, type],
  );

  if (!value) {
    return null;
  }

  return (
    <CommitmentsFilterSelect
      selectedValues={value}
      label="Based On The Past"
      options={lockBackPeriodFilterOptions}
      onChange={changeHandler}
      showSearch={false}
    />
  );
};
